import React from 'react';

import { ProjectImage, ProjectDiv,Details, Stack,ImageDiv} from "./style"

import { FaGithubSquare, FaShareSquare } from "react-icons/fa"

const Project = ({title, githubUrl,tagsModel, projectUrl, description:{description}, projectImage:{fluid}}) => {
  
  return (
    <ProjectDiv>
      <Details>
        <h1>{title}</h1>
        <p>{description}</p>
        <Stack>
          {tagsModel.map(item => {
            return <span key={item.id}>{item.tagName}</span>
          })}
        </Stack>
        <ul>
          <li>
            <a href={githubUrl} target="_blank" rel="noreferrer">
              <FaGithubSquare />
            </a>
          </li>
          {projectUrl && (
            <li>
              <a href={projectUrl} target="_blank" rel="noreferrer">
                <FaShareSquare />
              </a>
            </li>
          )}
        </ul>
      </Details>
      <ImageDiv>
        <ProjectImage fluid={fluid} />
      </ImageDiv>
    </ProjectDiv>
  )
}

export default Project;